// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen_oWz4_ {
  height: 100%;
  display: grid;
  overflow: hidden;
  grid-template-columns: 100%;
}

.screen_oWz4_.split_lweBv {
  grid-template-columns: 1fr 450px;
}

.header__Yvmo {
  display:flex;
  flex-direction:row;
  align-items:top;
  justify-content:space-between;
  padding: 10px 18px;
  border-bottom:5px solid #F4F6FA;
}
.card_Gx2Oq {
  height : 44px !important;
  border-left: 4px solid var( --color-brand500);
  margin: 8px 0;
  width : 80%;
  max-width: 400px;
}

.card_Gx2Oq.active_peRr7 {
  background-color: var( --color-brand100)!important;
}

.cardContents_Pc0ki {
  padding: 2px 4px;
  height : 100%;
  display: grid;
  column-gap: 8px;
  align-items: center;
  justify-items: start;
  grid-template-columns: 16px 1fr 1fr 40%;
}

.delete_gG3oE {
  justify-self: end;
  align-self: center;
}

.input_oOfaC {
  width : 100%;
  max-width : 400px;
  margin : 8px;
}`, "",{"version":3,"sources":["webpack://./src/screens/enum/EnumStyles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".screen {\n  height: 100%;\n  display: grid;\n  overflow: hidden;\n  grid-template-columns: 100%;\n}\n\n.screen.split {\n  grid-template-columns: 1fr 450px;\n}\n\n.header {\n  display:flex;\n  flex-direction:row;\n  align-items:top;\n  justify-content:space-between;\n  padding: 10px 18px;\n  border-bottom:5px solid #F4F6FA;\n}\n.card {\n  height : 44px !important;\n  border-left: 4px solid var( --color-brand500);\n  margin: 8px 0;\n  width : 80%;\n  max-width: 400px;\n}\n\n.card.active {\n  background-color: var( --color-brand100)!important;\n}\n\n.cardContents {\n  padding: 2px 4px;\n  height : 100%;\n  display: grid;\n  column-gap: 8px;\n  align-items: center;\n  justify-items: start;\n  grid-template-columns: 16px 1fr 1fr 40%;\n}\n\n.delete {\n  justify-self: end;\n  align-self: center;\n}\n\n.input {\n  width : 100%;\n  max-width : 400px;\n  margin : 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `screen_oWz4_`,
	"split": `split_lweBv`,
	"header": `header__Yvmo`,
	"card": `card_Gx2Oq`,
	"active": `active_peRr7`,
	"cardContents": `cardContents_Pc0ki`,
	"delete": `delete_gG3oE`,
	"input": `input_oOfaC`
};
export default ___CSS_LOADER_EXPORT___;
